import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type { SolicitacaoAssinatura } from '@/types/assinatura';

import { assinaturaService } from './services';

export const listarAssinaturasPorAdvogado = createAsyncThunk<SolicitacaoAssinatura[], string>(
  'assinatura/listarPorAdvogado',
  async (advogadoId, { rejectWithValue }) => {
    try {
      return await assinaturaService.listarPorAdvogado(advogadoId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as SolicitacaoAssinatura[];
    }
  },
);

export const assinarSolicitacaoViaToken = createAsyncThunk<
  void,
  { token: string; pfx: File; senha: string }
>('assinatura/assinarViaToken', async ({ token, pfx, senha }, { rejectWithValue }) => {
  try {
    await assinaturaService.assinarViaToken(token, pfx, senha);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as void;
  }
});

export const cancelarSolicitacaoAssinatura = createAsyncThunk<string, string>(
  'assinatura/cancelarSolicitacao',
  async (solicitacaoId, { rejectWithValue }) => {
    try {
      await assinaturaService.cancelarSolicitacao(solicitacaoId);
      return solicitacaoId;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error)) as unknown as string;
    }
  },
);

export const listarSolicitacoesAssinatura = createAsyncThunk<
  SolicitacaoAssinatura[],
  {
    status?: string[];
    numeroProcesso?: string;
    solicitante?: string;
    dataInicio?: string;
    dataFim?: string;
  }
>('assinatura/listarSolicitacoes', async (filtros, { rejectWithValue }) => {
  try {
    return await assinaturaService.listarSolicitacoes(filtros);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as SolicitacaoAssinatura[];
  }
});

export const enviarSolicitacaoParaAdvogado = createAsyncThunk<
  { id: string },
  { processoId: string; email: string; mensagem?: string }
>('assinatura/enviarParaAdvogado', async ({ processoId, email, mensagem }, { rejectWithValue }) => {
  try {
    const result = await assinaturaService.enviarParaAdvogado(processoId, email, mensagem);
    return { id: String(result?.id ?? '') };
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as { id: string };
  }
});

export const rejeitarSolicitacaoAssinatura = createAsyncThunk<
  void,
  { solicitacaoId: string; motivo: string }
>('assinatura/rejeitarSolicitacao', async ({ solicitacaoId, motivo }, { rejectWithValue }) => {
  try {
    await assinaturaService.rejeitarSolicitacao(solicitacaoId, motivo);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error)) as unknown as void;
  }
});
